"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.ButtonSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../../../LoadMore/styles");
const Root = exports.Root = (0, _mui.styled)(_styles.Root)(({
  theme
}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    width: 'auto'
  }
}));
const ButtonSkeleton = exports.ButtonSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '100%',
  height: 45,
  maxWidth: 500,
  borderRadius: theme.spacing(5),
  [theme.breakpoints.up('sm')]: {
    width: 135
  }
}));
